
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","d":"M6.5 4.5v1.25m-2 .75H6m-.632 3.342 4.474-4.474M9.5 12.5v-1.25m2-1.75h1m-1.987-1.895 1.119-.447M7.605 10.29l-.447 1.118M8.5 16v-1.75m0-11.5V1M1 8.5h1.75m11.5 0h1.684M9.95 7.125c1.27 1.252 1.69 2.885.939 3.647-.752.762-2.39.364-3.66-.888S5.539 7 6.29 6.237c.752-.762 2.39-.364 3.66.888M15.5 8.5a7 7 0 1 1-14 0 7 7 0 0 1 14 0"}})])
          )
        }
      }
    